import { render, staticRenderFns } from "./mSelect.vue?vue&type=template&id=de2abb22"
import script from "./mSelect.vue?vue&type=script&lang=js"
export * from "./mSelect.vue?vue&type=script&lang=js"
import style0 from "./mSelect.vue?vue&type=style&index=0&id=de2abb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports